/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';
import { getContentItemForSlot } from '@/data/utils/getContentItemForSlot';

export const getCheckOutPage = (props: IncomingContent): Layout => ({
	name: 'HomeStack',
	slots: {
		header: [{ name: 'ShortHeader', id: 'short-header' }],
		first: [...getContentItemForSlot(props, 'first'), { name: 'CheckOut', id: 'check-out' }],
		second: [...getContentItemForSlot(props, 'second')],
		footer: [{ name: 'ShortFooter', id: 'short-footer' }],
	},
});
